import { type SegmentEventProperties } from "../../../utils/useSegmentTrackEvent";

export const DATADOG_FEATURE = "Datadog";
export const OPENAI_FEATURE = "OpenAI";

export const CONNECTION_TEST_EVENT = "Connection Tested";

export const createConnectionTestEventProperties = (feature: string): SegmentEventProperties => ({
  pageType: "Dashboards",
  pageSubtype: `${feature} Lens`,
  feature,
  integration: feature,
});
